module.exports = __webpack_public_path__ + "img/godaddy-logo.fbbc5036.svg";